export default __webpack_public_path__ + "static/media/logo.965bf50a.png";